import { RootState } from '@reducers';

export const selectRequestDocumentsModal = (state: RootState) =>
  state.userDashboardRouteReducer.insuranceClaimDetailsPageReducer.requestDocumentsModalReducer;
